import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

function timeAgo(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.round(diff/60)}m ago`;
  if (diff < 86400) return `${Math.round(diff/3600)}h ago`;
  return `${Math.round(diff/86400)}d ago`;
}

function WinPill({ w }) {
  return (
    <div className="shrink-0 flex items-center gap-3 bg-white border border-slate-200 rounded-full pl-2 pr-4 py-2 shadow-sm" data-testid="win-pill">
      <div className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 grid place-items-center shrink-0">
        <CheckCircle2 className="w-4 h-4" />
      </div>
      <div className="flex items-center gap-2 whitespace-nowrap">
        <span className="text-xs font-bold text-slate-500">{w.initials || "?"}</span>
        <span className="text-sm font-semibold text-slate-900">${w.amount.toFixed(2)}</span>
        <span className="text-xs text-slate-500">from</span>
        <span className="text-sm font-semibold text-slate-900">{w.merchant_name}</span>
        <span className="text-xs text-slate-400">· {timeAgo(w.resolved_at)}</span>
      </div>
    </div>
  );
}

export default function WinsMarquee() {
  const [wins, setWins] = useState([]);
  useEffect(() => { api.get("/wins/feed").then((r) => setWins(r.data.wins || [])).catch(()=>{}); }, []);

  if (!wins.length) return null;
  const loop = [...wins, ...wins];

  return (
    <div className="relative overflow-hidden py-6" data-testid="wins-marquee">
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#FAFBFD] to-transparent z-10 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#FAFBFD] to-transparent z-10 pointer-events-none" />
      <div className="flex gap-3 marquee-track">
        {loop.map((w, i) => <WinPill key={i} w={w} />)}
      </div>
      <style>{`
        .marquee-track { animation: marquee 40s linear infinite; width: max-content; }
        @keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        .marquee-track:hover { animation-play-state: paused; }
      `}</style>
    </div>
  );
}
